import { useLanguageContext } from "../../../../context/LanguageContext";
import AccessCommander2NConfigPage from "../../../../pages/integrations/acces_commanders_2n_configs/access_commanders_2n_config/AccessCommander2NConfigPage";
import { useAccessCommander2NConfigEditRouteValidator } from "../../../validators/integrations/accessCommander2N/AccessCommander2NConfigEditRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useAccessCommander2NConfigsRouteConfig from "./AccessCommander2NConfigsRouteConfig";

function useAccessCommander2NConfigEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integration/access_commander/:access_commander/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.access_commander_2n_config"),
        },
      ])
    )
    .setValidator(useAccessCommander2NConfigEditRouteValidator())
    .setPage(<AccessCommander2NConfigPage />)
    .setParent(useAccessCommander2NConfigsRouteConfig());
}

export default useAccessCommander2NConfigEditRouteConfig;